"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractMessageHandler = exports.unsupportedMessageTypeError = void 0;
exports.unsupportedMessageTypeError = new Error('Unsupported message type');
/**
 * An abstract class for creating {@link @veramo/message-handler#MessageHandler} plugins
 * @public
 */
class AbstractMessageHandler {
    setNext(messageHandler) {
        this.nextMessageHandler = messageHandler;
        return messageHandler;
    }
    handle(message, context) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.nextMessageHandler) {
                return this.nextMessageHandler.handle(message, context);
            }
            return Promise.reject(exports.unsupportedMessageTypeError);
        });
    }
}
exports.AbstractMessageHandler = AbstractMessageHandler;
//# sourceMappingURL=abstract-message-handler.js.map